/*eslint-disable */
var $ = window.jQuery = require('jquery');
import draggable from 'vuedraggable'
import toast from '@/services/toast';
import {
mapGetters,
} from 'vuex';
import { VueEditor } from "vue2-editor";
export default {
  name: 'members-filters-categories',
  components: {
    VueEditor,
    draggable
  },
  props: [],
  data () {
    return {
      submitted:false,
      display_name:'',
      filter_key:'',
      file:null,
      uploadAttachmentName:'',
      createMemberFiltersPopup:false,
      getMemberFiltersListState:{},
      getMemberFiltersListResults:[],
      updateMemberFiltersPopup:false,
      updateMemberFiltersId:'',
      removeMemberFiltersPopup:false,
      removeMemberFiltersId:'',
      editorOptions: {
        placeholder: '',
        editorToolbar: ['bold','italic','link',  '|', 'heading', 'fontFamily','fontSize','undo','redo']
      },
      editorData: '',
      movedSectionIndex:'',
      movedSectionId:'',
      lbilOptionLabel:false,
      lbilOptionParentToChildLabel:false,
      lbilSelectParent:'',
      lbil_filter_img_key:null,
      lbil_filter_attachment_name:'',
      lbilOptionChildToParentLabel:'',
      lbil_display_name:''
    }
  },
  computed: {
    ...mapGetters([
      'getMemberMainFiltersGetters'
    ]),
    getMemberFiltersListFun(){
      this.getMemberFiltersListState = this.$store.getters.getMemberMainFiltersGetters.data;
      return
    },
    getMemerFilterInitialStateFun(){
      if(this.getMemberFiltersListState != undefined){
        this.getMemberFiltersListResults = this.getMemberFiltersListState.results
      }
      return
    },
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        ghostClass: "ghost"
      };
    }
  },
  mounted () {
    this.getMemberFiltersListFun
    this.getMemerFilterInitialStateFun
  },
  methods: {
    handleAttachmentUploadForLbil(event) {
      console.log(event)
      if (event.target.files && event.target.files.length > 0) {
        this.lbil_filter_img_key = event.target.files[0];
        this.lbil_filter_attachment_name = this.lbil_filter_img_key.name
      }else {
        this.lbil_filter_attachment_name = '';
      }
    },
    handleAttachmentUpload(event) {
      if (event.target.files && event.target.files.length > 0) {
        this.file = event.target.files[0];
        this.files = this.$refs.file.files[0];
        this.uploadAttachmentName = this.files.name
      }else {
        this.uploadAttachmentName = '';
      }
    },
    getMemberFiltersListAgainMethod(){
      this.$store.dispatch('getMemberMainFilterAction').then((res) => {
        this.getMemberFiltersListState = res.data.data
      })
      // this.$store.dispatch('getMemberFilterCountFun').then((res)=>{}).catch((err)=>{})
    },
    createMemberFiltersPopupFun(){
      this.createMemberFiltersPopup = true
      $('body').addClass('body_right_scroll_remove')
    },
    closeMemberFiltersPopupFun(){
      this.createMemberFiltersPopup = false
      $('body').removeClass('body_right_scroll_remove')
    },
    createMemberFilterBeforeSubmitMethod(){
      this.$validator.validateAll().then((result) => {
        if(result){
          this.submitted =  true
          var formData = new FormData();
          formData.append('display_name', this.display_name);
          formData.append('filter_key', this.filter_key);
          formData.append('image', this.file);
          this.$store.dispatch('createMemberMainFilterAction', formData).then((res) => {
            toast.success(res.data.msg);
            this.submitted = false
            this.getMemberFiltersListAgainMethod()
            this.closeMemberFiltersPopupFun()
            this.display_name = ''
            this.filter_key = ''
            this.file = null
            this.uploadAttachmentName =  ''
          }).catch((err)=>{
            this.submitted = false
            toast.error(err.data.msg);
          })
        }
      })
    },
    updateMemberFiltersPopupEnabledFun(filterId,filterData){
      $('body').addClass('body_right_scroll_remove')
      this.updateMemberFiltersId = filterId
      this.updateMemberFiltersPopup = true
      this.display_name = filterData.display_name
      this.filter_key = filterData.filter_key
      if(filterData.image.split('/')[6]){
        this.uploadAttachmentName = filterData.image.split('/')[6].split('?')[0]
      }else{
        this.uploadAttachmentName = filterData.image.split('/')[5].split('?')[0]
      }
      this.lbilOptionParentToChildLabel = filterData.lbil_child || false
      if(filterData.lbil_image){
        if(filterData.lbil_image.split('/')[6]){
          this.lbil_filter_attachment_name = filterData.lbil_image.split('/')[6].split('?')[0]
        }else{
          this.lbil_filter_attachment_name = filterData.lbil_image.split('/')[5].split('?')[0]
        }
      }else{ 
        this.lbil_filter_attachment_name = ''
      }
      this.lbilSelectParent =  filterData.lbil_parent_key || ''
      this.lbilOptionChildToParentLabel = filterData.lbil_parent || false
      this.lbil_display_name = filterData.lbil_display_name || ''
      if(this.lbilOptionParentToChildLabel || this.lbilOptionChildToParentLabel){
        this.lbilOptionLabel = true
      }else{
        this.lbilOptionLabel = false
      }
    },
    closeUpdateMemberFiltersPopupFun(){
      this.resetAllKeysOfLbilFiters();
      this.updateMemberFiltersPopup = false
      this.updateMemberFiltersId = ''
      this.display_name = ''
      this.filter_key = ''
      this.uploadAttachmentName =  ''
      $('body').removeClass('body_right_scroll_remove')
    },
    resetAllKeysOfLbilFiters(){
      this.lbilOptionParentToChildLabel = false
      this.lbil_filter_img_key = null
      this.lbil_filter_attachment_name = ''
      this.lbilSelectParent = ''
      this.lbilOptionChildToParentLabel = false
    },
    updateMemberFilterBeforeSubmitMethod(){
      this.$validator.validateAll().then((result) => {
        if(result){
          this.submitted =  true
          var formData = new FormData();
          formData.append('display_name', this.display_name);
          formData.append('filter_key', this.filter_key);
          if(this.file != null){
            formData.append('image', this.file);
          }
          formData.append('lbil_child', this.lbilOptionParentToChildLabel);
          formData.append('lbil_parent', this.lbilOptionChildToParentLabel);
          if(this.lbilOptionParentToChildLabel){
            if(this.lbilSelectParent != ''){
              formData.append('lbil_parent_key', this.lbilSelectParent);
            }
          }else{
            formData.append('lbil_parent_key', '');
          }
          if(this.lbil_filter_img_key != null){
            formData.append('lbil_image', this.lbil_filter_img_key);
          }
          if(this.lbil_display_name != null){
            formData.append('lbil_display_name', this.lbil_display_name);
          }
          if(this.lbilOptionChildToParentLabel){
            formData.append('lbil_child', false);
            formData.append('lbil_parent_key', '');
          }
          this.$store.dispatch('updateMemberMainFilterAction',{data:{data:formData,id:this.updateMemberFiltersId}}).then((res) => {
            toast.success(res.data.msg);
            this.submitted = false
            this.getMemberFiltersListAgainMethod()
            this.closeUpdateMemberFiltersPopupFun()
          }).catch((err)=>{
            this.submitted = false
            toast.error(err.data.msg);
          })
        }
      })
    },
    removeMemberFiltersPopupEnabledFun(filterId){
      this.removeMemberFiltersId = filterId
      this.removeMemberFiltersPopup = true
      $('body').addClass('body_right_scroll_remove')
    },
    closeRemoveMemberFiltersPopupFun(){
      this.removeMemberFiltersPopup = false
      this.removeMemberFiltersId = ''
      $('body').removeClass('body_right_scroll_remove')
    },
    removedMemberFiltersPopupFun(){
      this.$store.dispatch('deleteMemberMainFilterAction',{id:this.removeMemberFiltersId}).then((res) => {
        toast.success(res.data.msg);
        this.getMemberFiltersListAgainMethod()
        this.closeRemoveMemberFiltersPopupFun()
      }).catch((err)=>{
        toast.error(err.data.msg);
      })
    },
    SectionMovedFun({ relatedContext, draggedContext }) {
      this.movedSectionIndex = relatedContext.element.order
      this.movedSectionId = draggedContext.element.id
    },
    SectionMoveDragFun: function() {
      var data = {
        order: this.movedSectionIndex
      }
      this.$store.dispatch('updateINdexOfMemberMainFilterAction',{
        data: {
          data: data,
          id: this.movedSectionId
        }
      }).then((res) => {
        if (res.status == '200') {
          this.getMemberFiltersListAgainMethod();
          toast.success("Filter Index Updated Successfully");
        }
      }).catch((err) => {})
    }
  },
  watch: {
    getMemberFiltersListFun(){
      return this.$store.getters.getMemberMainFiltersGetters
    },
    getMemerFilterInitialStateFun(){
      if(this.getMemberFiltersListState != undefined){
        this.getMemberFiltersListResults = this.getMemberFiltersListState.results
      }
      return
    }
  },
  beforeRouteLeave: function(to, from, next) {
    $('body').removeClass('body_right_scroll_remove')
    next();
  },
}